import { NgModule } from '@angular/core'
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import { AdvancedSearchComponent } from './components/advanced-search/advanced-search.component'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { KeyingToastComponent } from './components/toast/toast.component'
import { MatIconModule } from '@angular/material/icon'
import { MatButtonModule } from '@angular/material/button'

@NgModule({ declarations: [AdvancedSearchComponent, KeyingToastComponent],
    exports: [AdvancedSearchComponent, KeyingToastComponent], imports: [CommonModule, FormsModule, ReactiveFormsModule, MatIconModule, MatButtonModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class KeyingSharedModule {}
